
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { detailActive } from '../../../redux/actions';
import * as api from '../../../api';
import * as textHelper from '../../../utils/TextHelper';
import './ItemDetail.css';
import { ITEM_TYPE, MAIN_SECTIONS, ROUTING, PATH } from '../../../constants';

class ItemDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoVisible: false,
      closeBg: false,
      articleChecked: false,
      videoActive: false,
      fetching: true,
      detailData: null,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.checkArticle = this.checkArticle.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.detailActive(true);
    window.addEventListener('scroll', this.handleScroll);
    this.dataUpdate();
  }

  componentDidUpdate(prevProps) {
    // todo - just quick not optimal solution - revise
    if (prevProps.match.params.detailId !== this.props.match.params.detailId) {
      this.dataUpdate();
    }
  }

  componentWillUnmount() {
    this.props.detailActive(false);
    window.removeEventListener('scroll', this.handleScroll);
  }

  // -------------------------------------------------------
  // Video
  // -------------------------------------------------------

  getContentVideo() {
    const { detailId } = this.props.match.params;
    const { detailData } = this.state;

    const isMemory = detailData.type === ITEM_TYPE.MEMORY;
    const hasInfo = detailData.type === ITEM_TYPE.VIDEO && detailData.idec.length > 0;
    const infoData = api.getInfo(detailId);

    let closeIcoClass = 'ico';
    if (this.state.closeBg) {
      closeIcoClass = `${closeIcoClass} show-bg`;
    }

    // tags
    const tags = detailData.tags.map(tag => (
      <Link
        key={encodeURIComponent(tag)}
        className="tag"
        to={`${ROUTING.TAG}/${tag}`}
        onClick={() => {
          setTimeout(() => {
            // todo - quick workaround
            window.scrollTo(0, 0);
          }, 100);
        }}
      >
        {tag}
      </Link>
    ));

    return (
      <div id="detail-wrap">
        <Link
          className="stamp-category"
          to={`${ROUTING.CATEGORY}/${detailData.category}`}
        >
          <img
            src={`${PATH.IMG}ico/stamps/stamp-${detailData.category}.png`}
            alt="Kategorie"
          />
          <div className="stamp-hint">
            <div className="stamp-wrap">
              <div className="range">{MAIN_SECTIONS[detailData.category].range}</div>
              <div className="title">{MAIN_SECTIONS[detailData.category].title}</div>
            </div>
          </div>
        </Link>
        <button
          className="btn-close"
          onClick={e => this.back(e)}
        >
          <img
            className={closeIcoClass}
            src={`${PATH.IMG}ico/ico-close.png`}
            alt="Zavřít"
          />
        </button>
        <div id="detail-content">
          {isMemory &&
          <div className="ico-wrap">
            <img
              className="ico-memory"
              src={`${PATH.IMG}ico/ico-memory-detail.png`}
              alt="paměť národa"
            />
          </div>
          }
          {detailData.timeline.length > 0 &&
          <div className="range">{detailData.timeline}</div>
          }
          <div className="title">{textHelper.formatText(detailData.title)}</div>
          {isMemory &&
          <div>
            <div className="memory-name">{detailData.name}</div>
            <div className="memory-date">{detailData.date}</div>
          </div>
          }
          <div className="description">{textHelper.formatText(detailData.desc)}</div>
          <div className="video-frame-cont">
            {!this.state.videoActive &&
            <button
              className="video-start-btn"
              onClick={() => this.setState({
                videoActive: true,
              })}
            >
              <img
                className="thumb"
                src={api.videoImageUrl(detailData)}
                alt={detailData.title}
              />
              <img
                className="ico"
                src={`${PATH.IMG}ico/ico-play.png`}
                alt="Přehrát"
              />
            </button>
            }
            {this.state.videoActive &&
            <iframe
              className="video-frame"
              title={detailData.title}
              src={api.getVideoSource(detailData)}
              allowFullScreen
            />
            }
          </div>
          <div className="info-bar">
            <div className="tags">{tags}</div>
            {hasInfo &&
            <button
              className="btn-info"
              onClick={() => this.infoSwitch()}
            >
              <img
                src={`${PATH.IMG}ico/ico-info.png`}
                alt="Info"
              />
            </button>
            }
          </div>
          {hasInfo && this.state.infoVisible &&
          <div className="info-wrap">
            <h3>Video z pořadu:</h3>
            {infoData.title && infoData.title.length > 0 &&
            <div className="title-show">
              {infoData.title}
            </div>
            }
            {infoData.partTitle && infoData.partTitle.length > 0 &&
            <div className="title-part">
              {infoData.partTitle}
            </div>
            }
            {infoData.description && infoData.description.length > 0 &&
            <div>
              {infoData.description}
            </div>
            }
            {detailData.director && detailData.director.length > 0 &&
            <div>
              <h4>Režie</h4>
              {detailData.director}
            </div>
            }
            {infoData.premiere && infoData.premiere.length > 0 &&
            <div>
              <h4>Premiéra</h4>
              {infoData.premiere}
            </div>
            }
            {infoData.link && infoData.link.length > 0 &&
            <a
              className="show-link"
              href={infoData.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Stránka pořadu
            </a>
            }
          </div>
          }
          {isMemory && detailData.link.length > 0 &&
          <div className="memory-link-wrap">
            <a
              className="memory-link"
              href={detailData.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Více o pamětníkovi
            </a>
          </div>
          }
        </div>
      </div>
    );
  }


  // -------------------------------------------------------
  // Vysilani
  // -------------------------------------------------------

  // todo - quite similar to video - somehow merge

  getContentVysilani() {
    const { detailData } = this.state;

    let closeIcoClass = 'ico';
    if (this.state.closeBg) {
      closeIcoClass = `${closeIcoClass} show-bg`;
    }

    return (
      <div id="detail-wrap">
        <button
          className="btn-close"
          onClick={e => this.back(e)}
        >
          <img
            className={closeIcoClass}
            src={`${PATH.IMG}ico/ico-close.png`}
            alt="Zavřít"
          />
        </button>
        <div id="detail-content">
          <div className="range">
            {`${detailData.date} - ${detailData.time} ${detailData.channel}`}
          </div>
          <div className="title">{textHelper.formatText(detailData.title)}</div>
          <div className="description">{textHelper.formatText(detailData.desc)}</div>
          <div className="video-frame-cont">
            {!this.state.videoActive &&
            <button
              className="video-start-btn"
              onClick={() => this.setState({
                videoActive: true,
              })}
            >
              <img
                className="thumb"
                src={api.videoImageUrl(detailData)}
                alt={detailData.title}
              />
              <img
                className="ico"
                src={`${PATH.IMG}ico/ico-play.png`}
                alt="Přehrát"
              />
            </button>
            }
            {this.state.videoActive &&
            <iframe
              className="video-frame"
              title={detailData.title}
              src={api.getVideoSource(detailData)}
              allowFullScreen
            />
            }
          </div>
          <div className="info-bar center">
            <a
              className="link"
              href={detailData.webURL}
              target="_blank"
            >
              Stránka pořadu
            </a>
          </div>
        </div>
      </div>
    );
  }

  // -------------------------------------------------------
  // Article
  // -------------------------------------------------------

  getContentArticle() {
    const { detailData } = this.state;

    const articleStyle = {
      visibility: this.state.articleChecked ? 'visible' : 'hidden',
    };
    return (
      <div id="article-wrap">
        <div className="top-bar">
          <button
            className="btn-close"
            onClick={e => this.back(e)}
          >
            <img
              src={`${PATH.IMG}ico/ico-close.png`}
              alt="Zavřít"
            />
          </button>
        </div>
        <div className="article-frame-cont">
          <div className="article-loader">NAČÍTÁM</div>
          <iframe
            className="article-frame"
            title={detailData.title}
            src={detailData.link}
            ref={(articleFrame) => { this.articleFrame = articleFrame; }}
            onLoad={this.checkArticle}
            style={articleStyle}
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  checkArticle() {
    // note - ugly but necessary workaround
    if (!this.state.articleChecked) {
      this.setState({
        articleChecked: true,
      });
      const currentSrc = this.articleFrame.src;
      this.articleFrame.src = currentSrc;
    }
  }

  // -------------------------------------------------------
  // Infographic
  // -------------------------------------------------------

  getContentInfographic() {
    const { detailData } = this.state;
    // todo - repeating code (also for video)
    let closeIcoClass = 'ico';
    if (this.state.closeBg) {
      closeIcoClass = `${closeIcoClass} show-bg`;
    }

    return (
      <div id="graph-wrap">
        <button
          className="btn-close"
          onClick={e => this.back(e)}
        >
          <img
            className={closeIcoClass}
            src={`${PATH.IMG}ico/ico-close.png`}
            alt="Zavřít"
          />
        </button>
        <img
          className="infographic"
          src={`${PATH.DATA}infographic/${detailData.image_id}.jpg`}
          alt={detailData.title}
        />
      </div>
    );
  }

  // -------------------------------------------------------
  // Data
  // -------------------------------------------------------

  dataError() {
    // todo - probably render some 'not found' content
    this.props.history.push(this.props.lastLocation);
  }

  dataUpdate() {
    const { detailId } = this.props.match.params;
    // reset to default
    this.setState({
      fetching: true,
      detailData: null,
    });
    // load data
    api.getItemData(detailId).then((data) => {
      if (data !== undefined) {
        this.setState({
          fetching: false,
          detailData: data,
        });
      } else {
        this.dataError();
      }
    }).catch(() => {
      this.dataError();
    });
  }

  // -------------------------------------------------------
  // Scroll
  // -------------------------------------------------------

  handleScroll() {
    // note - not ideal - but currently ok for this purpose
    const showBg = document.documentElement.scrollTop !== 0;
    if (this.state.closeBg !== showBg) {
      this.setState({
        closeBg: showBg,
      });
    }
  }

  // -------------------------------------------------------
  // Back
  // -------------------------------------------------------

  back(e) {
    e.stopPropagation();
    this.props.history.push(this.props.lastLocation);
  }

  // -------------------------------------------------------
  // Info
  // -------------------------------------------------------

  infoSwitch() {
    this.setState(prevState => ({
      infoVisible: !prevState.infoVisible,
    }));
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    if (!this.state.fetching) {
      // set content by type
      switch (this.state.detailData.type) {
        case ITEM_TYPE.VIDEO:
        case ITEM_TYPE.MEMORY:
          return this.getContentVideo();
        case ITEM_TYPE.VYSILANI:
          return this.getContentVysilani();
        case ITEM_TYPE.ARTICLE:
          return this.getContentArticle();
        case ITEM_TYPE.INFOGRAPHIC:
          return this.getContentInfographic();
        default:
          // todo - set backup content?
          return (
            <div>.</div>
          );
      }
    }
    // todo - probably show some proper fetching animation
    return (
      <div>.</div>
    );
  }
}

const mapStateToProps = state => ({
  lastLocation: state.dataDetail.lastLocation,
  menuOverlay: state.resize.menuOverlay,
  width: state.resize.width,
});

const mapDispatchToProps = dispatch => ({
  detailActive: isActive => dispatch(detailActive(isActive)),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemDetail));



// WEBPACK FOOTER //
// ./src/components/App/ItemDetail/ItemDetail.js